import constants from 'constants/constants';
import { useQuery } from 'react-query';

import { Report, getReport as queryFn } from 'api/endPoints/getReport';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetReport = (params: QueryParams) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['getReport', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.id),
        cacheTime: constants.MINUTE,
        staleTime: 10 * constants.SECOND,
    });
};

interface QueryParams {
    id: number;
}

export type QueryResponse = Report;
